// 审核员登录回退的**纯逻辑** —— web / mobile 共用一份，避免手工分叉（护栏 D）。
//
// 背景：DoneLine 只有 magic link 登录，审核员收不到那封邮件。服务端
// `POST /auth/review-session` 用预置凭据换出真 session（见 apps/api 的同名 service）。
// 客户端 UI **零改动**：审核员就在已有的「输入 6 位验证码」框里输我们给的码，
// Supabase 判无效之后自动回退到这条路。
//
// 为什么放这里而不是各端写一遍：这段判定（什么时候该回退、响应算不算合法）
// 一旦两端不一致，就会出现「iOS 审核过了 Android 没过」这种最难查的状况。

export interface ReviewSessionTokens {
  accessToken: string;
  refreshToken: string;
}

/**
 * 服务端响应 → tokens。形态不对一律返回 null（宁可让审核员看到「码错了」，
 * 也不能拿着半个 session 往下走）。
 */
export function parseReviewSessionResponse(json: unknown): ReviewSessionTokens | null {
  if (typeof json !== 'object' || json === null) return null;
  const o = json as Record<string, unknown>;
  if (typeof o.access_token !== 'string' || o.access_token.length === 0) return null;
  if (typeof o.refresh_token !== 'string' || o.refresh_token.length === 0) return null;
  return { accessToken: o.access_token, refreshToken: o.refresh_token };
}

/**
 * 这个 HTTP 状态该不该让客户端把「审核登录」当成一条走得通的路。
 *
 * 只有 200 才继续。401（码不对）/ 503（没配）/ 502（服务端换 session 失败）
 * 全都意味着回退失败 —— 此时应当把**原本的 Supabase 错误**抛给用户，
 * 而不是「审核登录失败」这种对普通用户毫无意义的提示。
 */
export function isReviewSessionOk(status: number): boolean {
  return status === 200;
}

/** 端点路径。base url 由各端从自己的 env 读（VITE_ / EXPO_PUBLIC_ 前缀不同）。 */
export const REVIEW_SESSION_PATH = '/auth/review-session';

/** 拼完整 URL，容忍 base 带尾斜杠（`https://api.x.app/` + path 会变成 //auth/...）。 */
export function reviewSessionUrl(baseUrl: string): string {
  return `${baseUrl.replace(/\/+$/, '')}${REVIEW_SESSION_PATH}`;
}
